<template>
  <span v-if="showRemark(scope)">
    <el-popover trigger="click" placement="top">
      <div v-if="showDiscount(scope)">
        <p>
          <span>
            {{ $t('addConfigModule.promotionPrice') }}：
            {{ scope.row.productInitListVO.promotionPrice }}
            {{ $t('addConfigModule.yuan') }}
          </span>
        </p>
        <p>
          <span
            v-if="scope.row.productInitListVO.discountEndDateTime == null &&
              scope.row.productInitListVO.discountStartDateTime == null"
          >
            {{ $t('addConfigModule.promotionTime') }}：{{ $t('addConfigModule.wu') }}
          </span>
          <span
            v-else
          >
            {{ $t('addConfigModule.promotionTime') }}：{{ scope.row.productInitListVO.discountStartDateTime }}
            {{ $t('addConfigModule.zhi') }}&nbsp;
            {{ scope.row.productInitListVO.discountEndDateTime }}
          </span>
        </p>
      </div>
      <div
        v-if="scope.row.productInitListVO &&
          scope.row.productInitListVO.isSpdc == 1 &&
          (isPartner && getStore('partnerAuth')=='1' || !isPartner)"
      >
        <p>
          <span>
            {{ $t('addConfigModule.serviceProviderPrice') }}：{{ scope.row.productInitListVO.spdcPrice }}
            {{ $t('addConfigModule.yuan') }}
          </span></p>
        <p v-if="scope.row.productInitListVO.isSpdcDiscount != null &&
          scope.row.productInitListVO.isSpdcDiscount == 1"
        >
          <span
            v-if="scope.row.productInitListVO.spdcDiscountStartTime == null &&
              scope.row.productInitListVO.spdcDiscountEndTime == null"
          >
            {{ $t('addConfigModule.promotionTime') }}：{{ $t('addConfigModule.wu') }}
          </span>
          <span
            v-else
          >
            {{ $t('addConfigModule.promotionTime') }}：{{ scope.row.productInitListVO.spdcDiscountStartTime }}&nbsp;
            {{ $t('addConfigModule.zhi') }}&nbsp;
            {{ scope.row.productInitListVO.spdcDiscountEndTime }}
          </span>
        </p>
      </div>
      <p v-html="scope.row.productInitListVO.remarks " />
      <div slot="reference" class="name-wrapper">
        <el-tag size="medium">
          <i>
            <img src="../../assets/remark.png" alt="err">
          </i>
        </el-tag>
      </div>
    </el-popover>
  </span>
</template>

<script>
import { getStore } from '@/utils/mUtils';
export default {
  name: 'PreciseMoreContent',
  data () {
    return {};
  },
  components: {},
  props: {
    scope: {
      type: Object,
      default: () => {}
    },
    isPartner: {
      type: Boolean,
      default: true
    }
  },
  computed: {},
  methods: {
    getStore,
    showRemark (scope) {
      if ((scope.row.productInitListVO && scope.row.productInitListVO.isSpdc && (this.isPartner && getStore('partnerAuth') == '1' || !this.isPartner)) ||
      // eslint-disable-next-line no-mixed-operators
          (scope.row.productInitListVO && scope.row.productInitListVO.isDiscount && scope.row.productInitListVO.promotionPrice != null) && !this.isPartner) {
        return true;
      } else {
        return false;
      }
    },
    showDiscount (scope) {
      if ((scope.row.productInitListVO && scope.row.productInitListVO.isDiscount) && !this.isPartner) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>

</style>
